export enum OrderAction {
	updateOrderItems = 0,
	changeOrderPaymentMethod = 1,
	addOrUpdateShipment = 2,
	changeInReview = 3,
	updateCustomerNumber = 4,
	vatCheck = 5,
	showSalesRepresentative = 6,
	ShowPaymentFilter = 7,
	ShowTimestamps = 8,
}
